export default {
    state: {
        cartItems: [],
        articulosPromo: [],      // <--- Nueva declaración
        articulosRegulares: [],   // <--- Nueva declaración
        cartItemsCart: [],
        viasEmbarque: {},
        detallePedidos: {},
        detalleDirEnvios: {},
        montosub: 0,
        loadingPrecios: true,
        totalpiezas: 0,
        iva: 0,
        total: 0,
        viacliente: '',
        aplicaPromoInfo: {},
        montoPromo: 0,
        montoneto: 0,
        direccionesenvio: []
    },
    getters: {

        loadingPrecios(state) {
            return state.loadingPrecios
        },
        cartItems(state) {
            return state.cartItems
        },
        cartItemsCart(state) {
            return state.cartItemsCart
        },
        montosub(state) {
            return state.montosub
        },
        totalpiezas(state) {
            return state.totalpiezas
        },
        iva(state) {
            return state.iva
        },
        total(state) {
            return state.total
        }
        ,
        viasEmbarque(state) {
            return state.viasEmbarque
        },
        direccionesenvio(state) {
            return state.direccionesenvio
        },
        viacliente(state) {
            return state.viacliente
        },
        detallePedidos(state) {
            return state.detallePedidos
        },
        detalleDirEnvios(state) {
            return state.detalleDirEnvios
        },
        aplicaPromoInfo(state) {
            return state.aplicaPromoInfo
        },
        montoPromo(state) {
            return state.montoPromo
        },
        montoNeto(state) {
            return state.montoneto
        },
        articulosPromo(state) {
            return state.articulosPromo
        },
        articulosRegulares(state) {
            return state.articulosRegulares
        }

    },
    mutations: {
        set_cartItems: (state, data) => {
            state.cartItems = data
        },
        set_cartItemsCart: (state, data) => {
            state.cartItemsCart = data
        },
        set_viasEmbarque: (state, data) => {
            state.viasEmbarque = data
        },
        set_direccionesenvio: (state, data) => {
            state.direccionesenvio = data
        },
        set_viacliente: (state, data) => {
            state.viacliente = data
        },
        set_totalpiezas: (state, data) => {
            let suma = 0;
            data.forEach(function (item) {
                item.ShoppingCart.forEach(function (sucursal) {
                    if (sucursal.cantidad2 > 0) {
                        suma += Number(sucursal.cantidad2)
                    }

                })
            });


            state.totalpiezas = suma
        },
        set_montosub: (state, data) => {
            state.loadingPrecios = true;

            // 1. HELPERS INTERNOS
            const toNum = v => {
                const n = parseFloat(v);
                return isNaN(n) ? 0 : n;
            };
            const round2 = v => Math.round((v + Number.EPSILON) * 100) / 100;
            const getPromo = (item) => item.active_promotion?.promocion || item.promocion?.promocion || item.promocion || null;

            let subtotalBruto = 0;
            let montoPromoTotal = 0;

            // --- PASO 1: LIMPIEZA, RESET Y CÁLCULO DE TOTAL BRUTO ---
            // Recorremos todo el carrito para limpiar cálculos previos y sumar el subtotal base
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                if (!item?.ShoppingCart) continue;

                item.tienePromo = false;
                // Determinamos el precio unitario base (con ajuste si existe)
                const pUnitario = round2(toNum(item.precio_ajuste?.valor ?? item.precio));
                item.precio_render = pUnitario;

                for (let j = 0; j < item.ShoppingCart.length; j++) {
                    const suc = item.ShoppingCart[j];
                    const qty = toNum(suc.cantidad2);

                    if (qty > 0) {
                        subtotalBruto = round2(subtotalBruto + round2(pUnitario * qty));
                    }
                    // Reset crucial de flags de promoción por sucursal
                    suc.aplicaPromo = false;
                    suc.cantidadPromo = 0;
                }
            }

            // --- PASO 2: AGRUPACIÓN POR PROMOCIÓN (TIPO PIEZAS) ---
            const promoGroups = new Map();
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                const pNode = getPromo(item);

                // Solo procesamos promociones basadas en cantidad de piezas (ej. 3+1)
                if (!pNode || pNode.tipo_operacion !== "piezas") continue;

                for (let j = 0; j < item.ShoppingCart.length; j++) {
                    const suc = item.ShoppingCart[j];
                    const qtyPedida = toNum(suc.cantidad2);
                    if (qtyPedida <= 0) continue;

                    const pKey = pNode.id;
                    if (!promoGroups.has(pKey)) {
                        promoGroups.set(pKey, { promo: pNode, items: [] });
                    }
                    promoGroups.get(pKey).items.push({
                        item,
                        suc,
                        qty: qtyPedida,
                        precio: item.precio_render
                    });
                }
            }

            // --- PASO 3: CÁLCULO DE BENEFICIOS CON FILTRO DE EXISTENCIA REAL ---
            promoGroups.forEach((group) => {
                const { promo, items } = group;
                const req = toNum(promo.requiere_cantidad);     // Ej: 3
                const ben = toNum(promo.beneficio_cantidad);   // Ej: 1
                const packageSize = req + ben;                  // Total: 4

                // VALIDACIÓN DE STOCK FÍSICO: ¿Podemos surtir lo suficiente para activar la promo?
                let totalSurtibleGlobal = 0;
                items.forEach(it => {
                    const stockFisico = toNum(it.suc.existencia || 0);
                    // Solo lo que el cliente pidió Y que además esté en estante cuenta para la promo
                    totalSurtibleGlobal += Math.min(it.qty, stockFisico);
                });

                // Solo si el stock físico real completa al menos un paquete, procedemos
                if (totalSurtibleGlobal >= packageSize) {
                    const numPaquetes = Math.floor(totalSurtibleGlobal / packageSize);
                    let remainingGratis = numPaquetes * ben;

                    // Ordenamos: queremos regalar lo más barato primero
                    items.sort((a, b) => a.precio - b.precio);

                    for (const prod of items) {
                        if (remainingGratis <= 0) break;

                        const stockSuc = toNum(prod.suc.existencia || 0);
                        const qtyCliente = toNum(prod.qty);

                        // El regalo solo puede asignarse a piezas que el cliente pidió 
                        // Y que además SÍ existan físicamente en esta sucursal (No Backorders)
                        const disponibleParaSurtir = Math.min(qtyCliente, stockSuc);

                        if (disponibleParaSurtir > 0) {
                            const freeQty = Math.min(disponibleParaSurtir, remainingGratis);

                            prod.suc.cantidadPromo = freeQty;
                            prod.suc.aplicaPromo = true;
                            prod.item.tienePromo = true;

                            // Sumamos al acumulador de descuentos
                            montoPromoTotal = round2(montoPromoTotal + round2(freeQty * prod.precio));
                            remainingGratis -= freeQty;
                        }
                    }
                }
            });

            // --- PASO 4: GENERACIÓN DE LÍNEAS PARA EL PEDIDO (SPLIT COBRADO/REGALO) ---
            const lineasFinalesParaPedido = [];
            data.forEach(item => {
                item.ShoppingCart.forEach(suc => {
                    const total = toNum(suc.cantidad2);
                    const regalo = toNum(suc.cantidadPromo);
                    const cobrado = total - regalo;

                    // Línea de productos cobrados
                    if (cobrado > 0) {
                        lineasFinalesParaPedido.push({
                            id_producto: item.id,
                            k_parte: item.k_parte,
                            descripcion: item.precio_ajuste?.Descripcion || item.descripcion,
                            unidad: item.precio_ajuste?.Unidad || 'PZA',
                            cantidad: cobrado,
                            precio_unitario: item.precio_render,
                            linea: item.linea,
                            subtotal_linea: round2(cobrado * item.precio_render),
                            es_promo: false,
                            nomsucursal: suc.nomsucursal,
                            sucursal: suc.sucursal
                        });
                    }

                    // Línea de productos de regalo (Precio 0)
                    if (regalo > 0) {
                        lineasFinalesParaPedido.push({
                            id_producto: item.id,
                            k_parte: item.k_parte,
                            //descripcion: `(PROMO) ${item.precio_ajuste?.Descripcion || item.descripcion}`,
                            descripcion: item.precio_ajuste?.Descripcion || item.descripcion,
                            unidad: item.precio_ajuste?.Unidad || 'PZA',
                            linea: item.linea,
                            cantidad: regalo,
                            precio_unitario: 0,
                            subtotal_linea: 0,
                            es_promo: true,
                            nomsucursal: suc.nomsucursal,
                            sucursal: suc.sucursal
                        });
                    }
                });
            });

            // --- PASO 5: TOTALIZADO FINAL Y ACTUALIZACIÓN DEL STATE ---
            const subtotalNeto = round2(subtotalBruto - montoPromoTotal);

            state.montosub = subtotalBruto.toFixed(2);       // El total si nada fuera gratis
            state.montoPromo = montoPromoTotal.toFixed(2);   // Cuánto dinero se está descontando
            state.montoneto = subtotalNeto.toFixed(2);       // Lo que el cliente realmente paga
            state.iva = round2(subtotalNeto * 0.16).toFixed(2);
            state.total = round2(subtotalNeto * 1.16).toFixed(2);

            // Guardamos las líneas procesadas para que generarPedido() las use
            state.articulosPromo = [...lineasFinalesParaPedido];
            state.cartItems = [...data];
            state.loadingPrecios = false;
        },
        /*set_montosub: (state, data) => {
            const toNum = v => Number(v ?? 0) || 0;
            const round2 = v => Math.round((v + Number.EPSILON) * 100) / 100;

            let subtotalBruto = 0;
            let montoPromo = 0;
            const processed = new Set();
            const getSucId = (suc) => toNum(suc.sucursal ?? suc.sucursal_id ?? suc.id ?? 0);

            const detectPromoNode = (item) => {
                if (!item) return null;
                if (item.active_promotion) return item.active_promotion.promocion;
                if (item.promocion) return item.promocion.promocion ?? item.promocion;
                return null;
            };

            // --- REINICIO DE BANDERAS Y CÁLCULO BRUTO ---
            data.forEach(item => {
                if (!item?.ShoppingCart) return;
                item.tienePromo = false; // Reset preventivo
                const precio = round2(toNum(item.precio_ajuste?.valor ?? item.precio));

                item.ShoppingCart.forEach(suc => {
                    const qty = toNum(suc.cantidad2);
                    subtotalBruto += precio * qty; // SUMA TOTAL DE LISTA
                    suc.aplicaPromo = false;
                    suc.cantidadPromo = 0;
                });
            });

            // --- AGRUPAR PROMOS ---
            const promoGroups = {};
            data.forEach(item => {
                const promoNode = detectPromoNode(item);
                if (!promoNode || promoNode.tipo_operacion !== "piezas") return;

                item.ShoppingCart.forEach(suc => {
                    const qty = toNum(suc.cantidad2);
                    if (qty <= 0) return;
                    const promoKey = `P:${promoNode.id}`;
                    if (!promoGroups[promoKey]) promoGroups[promoKey] = { promo: promoNode, items: [] };
                    promoGroups[promoKey].items.push({
                        item, suc, qty,
                        precio: round2(toNum(item.precio_ajuste?.valor ?? item.precio))
                    });
                });
            });

            // --- CALCULAR BENEFICIOS ---
            for (const promoKey in promoGroups) {
                const { promo, items } = promoGroups[promoKey];
                const req = toNum(promo.requiere_cantidad);
                const ben = toNum(promo.beneficio_cantidad);
                const packageSize = req + ben;
                let totalQty = items.reduce((acc, it) => acc + it.qty, 0);

                if (totalQty >= req) {
                    const paquetes = Math.floor(totalQty / packageSize);
                    const totalGratis = paquetes * ben;
                    const sorted = [...items].sort((a, b) => a.precio - b.precio);

                    let remainingGratis = totalGratis;
                    for (const prod of sorted) {
                        if (remainingGratis <= 0) break;
                        const freeQty = Math.min(prod.qty, remainingGratis);
                        prod.suc.cantidadPromo = freeQty;
                        prod.suc.aplicaPromo = freeQty > 0;
                        prod.item.tienePromo = true;
                        montoPromo += freeQty * prod.precio; // AHORRO TOTAL
                        remainingGratis -= freeQty;
                    }
                }
            }

            // --- RESULTADOS ---
            const subtotalConDescuento = round2(subtotalBruto - montoPromo);

            state.montosub = round2(subtotalBruto).toFixed(2); // El valor "grande" que querías
            state.montoneto = round2(subtotalConDescuento).toFixed(2); // El valor "grande" que querías
            state.montoPromo = round2(montoPromo).toFixed(2);
            state.iva = round2(subtotalConDescuento * 0.16).toFixed(2);
            state.total = round2(subtotalConDescuento * 1.16).toFixed(2);
            state.cartItems = data;
        },*/

        set_detallePedidos: (state, data) => {
            state.detallePedidos = data
        },
        set_detalleDirEnvios: (state, data) => {
            state.detalleDirEnvios = data
        }
    },
    actions: {
        cartItems: (context) => {
            axios.get('/getItems').then((response) => {
                context.commit('set_montosub', response.data.carrito)
                context.commit('set_totalpiezas', response.data.carrito)
                context.commit('set_viasEmbarque', Object.values(response.data.vias))
                context.commit('set_viacliente', response.data.viacliente ? response.data.viacliente.toString() : '');
                context.commit('set_cartItems', response.data.carrito)
            }).catch((error) => {
                if (error.response && error.response.status === 401) {
                    window.Toast.fire({
                        title: 'Sesión Expirada',
                        text: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    }).then(() => {
                        // Redirigir al usuario a la página de inicio de sesión si es necesario
                        window.location.href = '/login'; // Ajusta la URL de inicio de sesión según tu aplicación
                    });
                } else {
                    console.log(error);
                }
            });

        },
        updateCartItems: (context, items) => {
            context.commit('set_montosub', items)
            context.commit('set_totalpiezas', items)
            //context.commit('set_cartItems', items)
            //context.commit('set_viasEmbarque', Object.values(response.data.vias))
            //context.commit('set_viacliente', response.data.viacliente ? response.data.viacliente.toString() : '');
            //context.commit('set_cartItems', response.data.carrito)
            context.commit('set_cartItemsCart', items)
        },
        calculaprecios: (context) => {
            axios.get('/cartItems/getItems/').then((response) => {
                //   context.commit('set_cartItems', response.data)
                context.commit('set_montosub', response.data.carrito)
                context.commit('set_totalpiezas', response.data.carrito)
                context.commit('set_cartItemsCart', response.data.carrito)

            }).catch((error) => {
                if (error.response && error.response.status === 401) {
                    window.Toast.fire({
                        title: 'Sesión Expirada',
                        text: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    }).then(() => {
                        // Redirigir al usuario a la página de inicio de sesión si es necesario
                        window.location.href = '/login'; // Ajusta la URL de inicio de sesión según tu aplicación
                    });
                } else {
                    console.log(error);
                }
            });

        },
        generaCarrito: (context, datosCarrito) => {
            axios.post('/cartItems/generacionCarrito/', datosCarrito).then((response) => {                
                context.commit('set_detallePedidos', response.data.procesado)
                context.commit('set_detalleDirEnvios', response.data.direnvio)

                $router.push({ name: 'DetallePrepedido' });
            }).catch((error) => {
                console.log(error)
            });

        },
    },
}